import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Dialog } from "@headlessui/react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import FilterOption from "./FilterOption";
import DialogBackdrop from "components/ModalDialogs/DialogBackdrop";

export default function FilterDialog({ dialogState, setDialogState }) {
  const location = useLocation();
  const { register, setValue, handleSubmit } = useForm({
    defaultValues: {},
  });

  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();

  useEffect(() => {
    if (searchParams.get("type"))
      setValue("type", searchParams.get("type").split(","));
    else setValue("type", "");
    if (searchParams.get("policyType"))
      setValue("policyType", searchParams.get("policyType").split(","));
    else setValue("policyType", "");
  }, [searchParams, location.pathname]);

  const setFilter = (data) => {
    let updatedSearchParams = new URLSearchParams(searchParams.toString());
    if (data?.type) updatedSearchParams.set("type", data.type);
    if (data?.paymentStatus)
      updatedSearchParams.set("paymentStatus", data.paymentStatus);
    if (data?.policyType)
      updatedSearchParams.set("policyType", data.policyType);
    else updatedSearchParams.set("policyType", "");
    setSearchParams(updatedSearchParams.toString());
    setDialogState(false);
  };

  const policyStatusOptions = [
    {
      label: t("AgentPolicyLookup-form-inactive"),
      value: "inactive",
    },
    {
      label: t("AgentPolicyLookup-form-inforce"),
      value: "inforce",
    },
    {
      label: t("AgentPolicyLookup-form-ingrace"),
      value: "ingrace",
    },
    {
      label: t("AgentPolicyLookup-form-lapsed"),
      value: "lapsed",
    },
  ];

  const policyTypeOptions = [
    { label: t("AgentPolicyLookup-form-annuity"), value: "annuity" },
    { label: t("AgentPolicyLookup-form-termLife"), value: "termlife" },
    {
      label: t("AgentPolicyLookup-form-universalLife"),
      value: "universallife",
    },
    { label: t("AgentPolicyLookup-form-wholeLife"), value: "wholelife" },
  ];

  return (
    <Dialog
      open={dialogState}
      onClose={() => setDialogState(false)}
      className="ui-dialogs"
    >
      <DialogBackdrop />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel
          role="dialog"
          aria-modal="true"
          className="ui-default-dialog"
        >
          <Dialog.Title className="font-body text-xl font-bold text-left">
            {t("AgentPolicyLookup-FilterPolicies")}
          </Dialog.Title>
          <button
            className="ui-default-dialog-close"
            aria-label="close manage notification preferences window"
            onClick={() => setDialogState(false)}
          >
            <svg
              className="ui-icon h-3.5 w-3.5"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-close"></use>
            </svg>
          </button>
          <hr />
          <Dialog.Description>
            {t("AgentPolicyLookup-Dialog-Description")}
          </Dialog.Description>
          <form onSubmit={handleSubmit(setFilter)}>
            <div className="grid grid-cols-2 md:grid-cols-2 md:gap-x-6 lg:grid-cols-2 lg:gap-0">
              <fieldset>
                <legend>{t("AgentPolicyLookup-form-showPolicies")}</legend>
                {policyStatusOptions.map((status) => (
                  <FilterOption
                    key={status.value}
                    register={register}
                    registerName="type"
                    {...status}
                  />
                ))}
              </fieldset>

              <fieldset>
                <legend>{t("AgentPolicyLookup-FilterDialog")}</legend>
                {policyTypeOptions.map((type) => (
                  <FilterOption
                    key={type.value}
                    register={register}
                    registerName="policyType"
                    {...type}
                  />
                ))}
              </fieldset>
            </div>

            <div className="block text-right">
              <button
                className="ui-btn-secondary ui-btn-min-w mt-4"
                onClick={() => setDialogState(false)}
              >
                {t("AgentPolicyLookup-Cancel")}
                <span className="sr-only"> filtering policies</span>
              </button>
              <button className="ui-btn-primary ui-btn-min-w mt-4">
                {t("AgentPolicyLookup-Apply")}
                <span className="sr-only"> filter to policies</span>
              </button>
            </div>
          </form>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
